import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=7774b777&scoped=true&"
import script from "./ResourceDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDialog.vue?vue&type=style&index=0&id=7774b777&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774b777",
  null
  
)

export default component.exports